<template lang="pug">
  .view-control-reports-lessons
    .navbar.is-light
      .navbar-item
        b-switch(v-model="groupByUser") Группировка по пользователю

    statistic(:url="statisticUrl" :expanded="!groupByUser" @expand="goToDetailedView")
</template>

<script>
export default {
  name: 'view-control-reports-lessons',

  data: () => ({
    groupByUser: false,
  }),

  computed: {
    statisticUrl() {
      return this.groupByUser ? '/statistics/users-progress' : '/statistics/lessons-progress';
    },
  },

  methods: {
    goToDetailedView(lessonId, userId = null) {
      if (!this.groupByUser) {
        if (userId) {
          this.$router.push({
            name: 'control.reports.detailed-lesson',
            params: { lessonId, userId },
          });
        } else {
          this.$router.push({
            name: 'control.reports.lesson',
            params: { lessonId },
          });
        }
      }
    },
  },
};
</script>
